// extracted by mini-css-extract-plugin
module.exports = {"popover__none":"OtherChainsButton_popover__none__3JIpc","popover":"OtherChainsButton_popover__jIfMX","button":"OtherChainsButton_button__3MX9B"};